export const boardRoadmapTour = {
  key: "boardRoadmap",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-roadmap-timeline"]',
      content: t("Tour_BoardRoadmap_Timeline"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-roadmap-releaseorder"]',
      content: t("Tour_BoardRoadmap_ReleaseOrder"),
      placement: "right",
    },
    {
      target: '[data-tour="board-roadmap-advanced"]',
      content: t("Tour_BoardRoadmap_Grouping"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-roadmap-grid"]',
      content: t("Tour_BoardRoadmap_Filter"),
      placement: "bottom",
    },
    {
      target: '[data-tour="board-roadmap-drag"]',
      content: t("Tour_BoardRoadmap_Drag"),
      placement: "top",
    },
  ],
};

